'use strict';

module.exports = {
    campaignModel: 'campaignModel',
    startDateModel: 'startDateModel',
};
